import { Col, Row } from 'antd';
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import NumberFormat from 'react-number-format';

import styles from './DoughnutGrade.module.css';

interface DoughnutGradeProps {
  grade?: number;
}

const DoughnutGrade: React.FC<DoughnutGradeProps> = ({ grade }) => {
  const data = {
    labels: [],
    datasets: [
      {
        label: '',
        data: [grade, 100 - (grade || 0)],
        backgroundColor: ['#166889', '#E0E1E2'],
        borderWidth: 1,
      },
    ],
  };

  return (
    <Row className={styles.graph__container} justify="center">
      <Doughnut options={{ events: [] }} data={data} />
      <Col className={styles.graph__text}>
        {grade ? <NumberFormat value={grade.toFixed()} displayType="text" /> : '-'}
      </Col>
    </Row>
  );
};

export default DoughnutGrade;
